import DOMPurify from 'dompurify'
import { escape } from 'he'
import MarkdownIt from 'markdown-it'
import { getURLFromString } from '@omnea-app/frontend/utils/general/getURLFromString'

export const renderMarkdownToHtml = (markdownString: string, variables?: Record<string, string>) => {
  const md = new MarkdownIt({
    html: true,
    linkify: true,
    breaks: true,
    typographer: true,
  })
  md.linkify.set({ fuzzyEmail: false })
  md.normalizeLink = (url: string) => getURLFromString(url)?.toString() || url

  let htmlString = md.render(markdownString)

  if (variables) {
    Object.entries(variables).map(([key, value]) => {
      htmlString = htmlString.replaceAll(`{{${key}}}`, escape(value))
    })
  }

  /* Note(Diego): Sanitising here is crucial to avoid XSS attacks. This strips alert, script, onload, and other dangerous HTML tags*/
  htmlString = DOMPurify.sanitize(htmlString)

  return htmlString
}
